<div class="sidebar">
     <h3 class="sidebar-heading">
          Recent Interview Codes
          <!-- <span class="arrow-icon" [ngClass]="{'rotated': isDropdownOpen}" (click)="toggleDropdown()" *ngIf="isMobile">
               &#9660;
          </span> -->
     </h3>

     <div class="sidebar-list sidebar-list-simple">
          <div *ngFor="let prompt of prompts " class="sidebar-simple-item"
               [class.selected]="selectedPrompt?.id === prompt.id" (click)="navigateToPrompt(prompt.id)" tabindex="0">
               <div class="sidebar-simple-code">{{prompt.id}}</div>
               <div class="sidebar-simple-name">{{prompt.consultantName || prompt.name}}</div>
          </div>
     </div>

     <!-- <div *ngIf="isMobile && isDropdownOpen" class="sidebar-list sidebar-list-simple">
          <div *ngFor="let prompt of prompts | slice:0:6" class="sidebar-simple-item"
               [class.selected]="selectedPrompt?.id === prompt.id" (click)="navigateToPrompt(prompt.id)" tabindex="0">
               <div class="sidebar-simple-code">{{prompt.id}}</div>
               <div class="sidebar-simple-name">{{prompt.consultantName || prompt.name}}</div>
          </div>
     </div> -->
</div>